import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal } from 'antd';

class HideComm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
  };
  render() {
    return (
      <span>
        <Modal
          open={this.state.visible}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title="用户评价"
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="440px"
          zIndex="1002"
          onCancel={this.hideModal}
        >
          <div className="hide-comm-remark">
            <div className="hide-comm-remark-bg">
              <h3>用户评价</h3>
              <dl>
                <dt>◆ 为什么评价会被隐藏？</dt>
                <dd>
                  大神不认可用户的评价，向平台提出申诉后，如果平台经取证判定该用户评价不合理，则会隐藏该条评价。
                </dd>
              </dl>
              <dl>
                <dt>◆ 什么样的评价是不合理的？</dt>
                <dd>
                  评价内容与平台内容发布规范不符，涉嫌侮辱、色情、侵犯隐私等；大神有证据证明为用户恶意差评等。
                </dd>
              </dl>
            </div>
          </div>
        </Modal>
      </span>
    );
  }
}

export default withRouter(HideComm, { withRef: true });
